import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import PreviewPage from "./pages/PreviewPage";
import PreviewPage2 from "./pages/PreviewPage2";
import PreviewPage3 from "./pages/PreviewPage3";
import "./styles/globals.css";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "var(--bg-3)",
            color: "var(--text)",
            border: "1px solid var(--border)",
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.85rem",
          },
        }}
      />
      <Routes>
        <Route path="/"        element={<PreviewPage3 />} />
        <Route path="/preview"   element={<PreviewPage />} />
        <Route path="/preview-2" element={<PreviewPage2 />} />
        <Route path="/preview-3" element={<PreviewPage3 />} />
        <Route path="/admin"   element={<AdminPage />} />
        <Route path="*"        element={<PreviewPage3 />} />
      </Routes>
    </BrowserRouter>
  );
}
